// Minimum length before a freetext search hits the API. The list endpoints are
// backed by pg_trgm trigram indexes, which need at least 3 characters to match
// a whole trigram; 1-2 char terms can't use the index (they'd full-scan) and
// match too much to be useful. See GRAIN-2452 / GRAIN-2384.
export const MIN_SEARCH_LENGTH = 3;

// Normalises a raw search term into the `q` API param: the trimmed term once it
// reaches MIN_SEARCH_LENGTH, otherwise undefined so no filtered request fires.
// Empty input returns undefined too (the unfiltered list). Keeping this in one
// place means every list page's query key is stable across 0/1/2 characters.
export function searchQueryParam(term: string | null | undefined): string | undefined {
  const trimmed = term?.trim() ?? '';
  return trimmed.length >= MIN_SEARCH_LENGTH ? trimmed : undefined;
}
